module.exports = __webpack_public_path__ + "img/shield-fill-minus.045a8513.svg";